import { render, staticRenderFns } from "./CmgQrCode.vue?vue&type=template&id=4c61ad6b&scoped=true&lang=pug&"
import script from "./cmg-qr-code.ts?vue&type=script&lang=ts&"
export * from "./cmg-qr-code.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61ad6b",
  null
  
)

export default component.exports